import { IContractStatementSegment, IContractStatementtype, } from "@domains/entities/interfaces/Reports/ContractReport/iContractStatement";
export const contractNotesFilters = {
    [IContractStatementtype.CONTRACT]: {
        filterName: IContractStatementtype.CONTRACT,
        list: [
            { title: "Cash", key: IContractStatementSegment.EQ, selected: true },
            {
                title: "Mutual Fund",
                key: IContractStatementSegment.MF,
                selected: false,
            },
            { title: "F&O", key: IContractStatementSegment.FO, selected: false },
            { title: "Currency", key: IContractStatementSegment.CU, selected: false },
        ],
        selectType: "radio",
        eventKey: "t1",
    },
    [IContractStatementtype.BILL]: {
        filterName: IContractStatementtype.BILL,
        list: [
            { title: "Cash", key: IContractStatementSegment.EQ, selected: true },
            { title: "F&O", key: IContractStatementSegment.FO, selected: false },
            { title: "Currency", key: IContractStatementSegment.CU, selected: false },
        ],
        selectType: "radio",
        eventKey: "t2",
    },
    [IContractStatementtype.MARGIN]: {
        filterName: IContractStatementtype.MARGIN,
        list: [
            { title: "F&O", key: IContractStatementSegment.FO, selected: true },
            { title: "Currency", key: IContractStatementSegment.CU, selected: false },
        ],
        selectType: "radio",
        eventKey: "t3",
    },
    [IContractStatementtype.AGTS]: {
        filterName: IContractStatementtype.AGTS,
        list: [
            {
                title: IContractStatementtype.AGTS,
                key: IContractStatementtype.AGTS,
                selected: true,
            },
        ],
        selectType: "radio",
        eventKey: "t4",
    },
};
export const commodityAccAddSegment = {
    title: "Commodity",
    key: IContractStatementSegment.CO,
    selected: false,
};
